import { render, staticRenderFns } from "./calcSalary.vue?vue&type=template&id=6223b7b2&scoped=true&"
import script from "./calcSalary.vue?vue&type=script&lang=js&"
export * from "./calcSalary.vue?vue&type=script&lang=js&"
import style0 from "./calcSalary.vue?vue&type=style&index=0&id=6223b7b2&prod&lang=scss&scoped=true&"
import style1 from "./calcSalary.vue?vue&type=style&index=1&id=6223b7b2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6223b7b2",
  null
  
)

export default component.exports